import { Component, ViewEncapsulation } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CerrixTextInputBase } from "../cerrix-textinput-base";
import { InputTooltipDirective } from "@app/shared/directives/input-tooltip.directive";

@Component({
    selector: "cerrix-textfield",
    templateUrl: "./cerrix-textfield.component.html",
    styleUrls: ["../cerrix-textinput.component.scss"],
    encapsulation: ViewEncapsulation.None,
    imports: [FormsModule, InputTooltipDirective]
})
export class CerrixTextfieldComponent extends CerrixTextInputBase {
    public constructor() {
        super();
        this.control.valueAccessor = this;
    }
}
